import React from 'react';

const DocTitle=props=>{
    return (
        <div className='container'>
            <div className="row">
                <div className="col-sm">
                <h3>Project Gorgon : Document Data Extraction</h3>
                </div>
            </div>
        </div>
    )
}

export default DocTitle;


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/DocTitle.js